<template>
    <Teleport to="body">
        <div data-testid="job-task-dialog" v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-worktask" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">

            <div class="modal-dialog" v-bind:class="size" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary">
                        Hantera
                    </div>

                    <div class="modal-body pb-0">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col">
                                        <CommonMCEEditor v-bind:disabled="disabled" title="Namn" testIdBase="job-task-name" v-model:editorcontent="name"></CommonMCEEditor>
                                    </div>
                                </div>

                                <div class="row mt-5">
                                    <div class="col">
                                        <CommonMCEEditor v-bind:disabled="disabled" title="Utbildning" testIdBase="job-task-education" v-model:editorcontent="educationAndRequirements"></CommonMCEEditor>
                                    </div>
                                </div>

                                <div class="row mt-5" v-show="option == 'task'">
                                    <div class="col">
                                        <CommonMCEEditor v-bind:disabled="disabled" title="Kommentarer" testIdBase="job-task-comments" v-model:editorcontent="comments"></CommonMCEEditor>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </div>

                    <div class="modal-footer pt-2 pb-1">
                        <v-btn data-testid="job-task-close-button" color="blue-darken-1"
                               variant="text"
                               @click="close">
                            Stäng
                        </v-btn>
                        <v-btn v-bind:disabled="disabled" data-testid="job-task-save-button" color="blue-darken-1"
                               variant="text"
                               @click="save">
                            Spara
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </Teleport>
</template>

<script>

    import ValidationService from "../../Services/ValidationService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import CommonMCEEditor from '../../common/common-mce-editor.vue'
    import { getCurrentInstance } from 'vue'
    import { ref, nextTick } from 'vue'
    const form = ref(null);

    export default {
        emits: ['taskupdated', 'suggestionupdated'],
        name: 'update-worktask',
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
            CommonMCEEditor
        },
        methods: {
            changedRequirements(v) {
                this.educationAndRequirements = v;
            },
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.taskid = -1;
                this.name = "";
                this.educationAndRequirements = "";
                this.comments = "";
                this.dialogueVisible = false;
                this.option = "task";
                this.thisModal.hide();
                this.jobPositionId = -1;
            },
            async save() {

                var result = await this.form.validate();
                if (result.valid != true)
                    return;

                    /*
                var pingResult = await WorkOrganisationService.ping()
                if (pingResult != true) {
                    window.emitter.emit('display_login')
                    return;
                }
                */
                if (this.option == "task") {
                    var savedTask = null;
                    if (this.taskid == -1)
                        savedTask = await WorkOrganisationService.addJobPositionTask(this.jobPositionId, this.name, this.educationAndRequirements, this.comments);
                    else
                        savedTask = await WorkOrganisationService.updateJobPositionTask(this.taskid, this.name, this.educationAndRequirements, this.comments);
                    this.$emit("taskupdated", savedTask);    
                }
                else if (this.option == "suggestion") {
                    if (this.taskid == -1)
                        await WorkOrganisationService.addJobPositionTaskSuggestion(this.name, this.educationAndRequirements);
                    else
                        await WorkOrganisationService.updateJobPositionTaskSuggestion(this.taskid, this.name, this.educationAndRequirements);
                
                    this.$emit("suggestionupdated");  
                }
                this.dialogueVisible = false;
                this.jobPositionId = -1;
                this.option = "task";
                
                this.thisModal.hide();
            },
            async openTask(item) {
                this.taskid = item.Id
                this.name = item.Name;
                this.educationAndRequirements = item.EducationAndRequirements;
                this.comments = item.Comments;
                this.dialogueVisible = true;
                this.option = "task";
                await nextTick();
                this.thisModal.show();
            },
            async openSuggestion(item) {
                this.taskid = item.Id
                this.name = item.Name;
                this.educationAndRequirements = item.EducationAndRequirements;
                this.comments = ""; //No comments on suggestions
                this.dialogueVisible = true;
                this.option = "suggestion";
                await nextTick();
                this.thisModal.show();
            },
            async createTask(jobPositionId) {
                this.jobPositionId = jobPositionId;
                this.taskid = -1;
                this.name = "";
                this.educationAndRequirements = "";
                this.comments = "";
                this.dialogueVisible = true;
                this.option = "task";
                await nextTick();
                this.thisModal.show();
            },
            async createSuggestion() {
                this.taskid = -1;
                this.name = "";
                this.educationAndRequirements = "";
                this.comments = "";
                this.dialogueVisible = true;
                this.option = "suggestion";
                await nextTick();
                this.thisModal.show();
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                rules: ValidationService.rules(),
                dialogueVisible: false,
                educationAndRequirements: "",
                comments: "",
                name: "",
                taskid: -1,
                jobPositionId: -1,
                option: "task",
                thisModal: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            //this.$el.remove();
            //document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

            //window.emitter.on('display_login', this.close);
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { form }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content{
        border-radius:unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }
    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius:unset;
    }
</style>
